// React for Website

import React from "react";
import { useNavigate, useParams } from "react-router-dom";
//outsource
import { Row, Col, List, Space, Button, Popconfirm, message } from "antd";
import { AiFillGift } from "react-icons/ai";
import { BsTrash } from "react-icons/bs";
import moment from "moment";
//components

//redux
import { useDispatch } from "react-redux";
import {
  archiveVoucherById,
  activateVoucherById,
  deleteVoucherById,
} from "../../../store/voucher/voucher.action";

const VoucherCard = ({ data }) => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id || "";
  const voucherId = data?.id || "";
  const name = data?.name || "";
  const shopId = data?.shopId || "";
  const packageId = data?.packageId || "";
  const title = `${name} | ${shopId} | ${packageId}`;
  const address = data?.address;
  const active = data?.active || false;
  const createAt = data?.createAt
    ? moment(data?.createAt?.toDate()).format("DD MMM YYYY")
    : "";

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION -----------------------
  const handleConfirmArchive = () => {
    dispatch(archiveVoucherById({ voucherId }), (response) => {
      if (response.status === 200) {
        message.success("The voucher was archived!");
      } else {
        message.error(response.data || "Error. Please try again!");
      }
    });
  };

  const handleConfirmActivate = () => {
    dispatch(activateVoucherById({ voucherId }), (response) => {
      if (response.status === 200) {
        message.success("The voucher was activate!");
      } else {
        message.error(response.data || "Error. Please try again!");
      }
    });
  };

  const handleDelete = () => {
    dispatch(deleteVoucherById({ voucherId }), (response) => {
      if (response.status === 200) {
        message.success("The voucher was deleted!");
      } else {
        message.error(response.data || "Error. Please try again!");
      }
    });
  };

  const handleEdit = () => {
    if (id !== "") {
      const href = `/branchs/detail/${id}/voucher/detail/${packageId}`;
      navigate(href);
    }
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBodyCard = () => {
    return (
      <div className={!active ? "voucher-deactive" : ""}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 style={{ margin: 0 }}>{title} </h1>
          <span style={{ marginLeft: 20 }}>(Created on {createAt})</span>
        </div>
        <p>{address}</p>
      </div>
    );
  };

  const renderButtonGroup = () => {
    const textArc = "Do you want to archive this voucher?";
    const textAct = "Do you want to activate this voucher?";
    const textDelete = "Are you sure to delete this voucher?";
    if (active) {
      return (
        <Space>
          <Button onClick={handleEdit} type="primary">
            Edit
          </Button>
          <Popconfirm
            title={textArc}
            onConfirm={handleConfirmArchive}
            okText="Yes"
            cancelText="No"
          >
            <Button type="default">Archive</Button>
          </Popconfirm>
          <Popconfirm
            title={textDelete}
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="default"
              style={{ borderColor: "red" }}
              icon={
                <span className="anticon">
                  <BsTrash style={{ color: "red" }} />
                </span>
              }
            />
          </Popconfirm>
        </Space>
      );
    }

    return (
      <Space>
        <Button disabled={!active} type="primary">
          Edit
        </Button>
        <Popconfirm
          title={textAct}
          onConfirm={handleConfirmActivate}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="default"
            style={{ backgroundColor: "#53c653", color: "white", border: 0 }}
          >
            Activate
          </Button>
        </Popconfirm>
        <Popconfirm
          title={textDelete}
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="default"
            style={{ borderColor: "red" }}
            icon={
              <span className="anticon">
                <BsTrash style={{ color: "red" }} />
              </span>
            }
          />
        </Popconfirm>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <List.Item>
      <Row
        gutter={[20]}
        style={{
          width: "100%",
          minHeight: 70,
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        <Col span={2}>
          <AiFillGift size={50} className={!active ? "voucher-deactive" : ""} />
        </Col>
        <Col flex="auto">{renderBodyCard()}</Col>
        <Col align="right" span={4}>
          {renderButtonGroup()}
        </Col>
      </Row>
    </List.Item>
  );
};

export default VoucherCard;
